import PropTypes from "prop-types";
import { Popover, PopoverContent, PopoverItem, PopoverTrigger } from "@shared/v2/Popover";
import { EllipsisSolidV6, PencilSolidV6, CheckSolidV6, EyeSolidV6, TrashSolidV6 } from "@shared/v2/Icomoon";
import IconButton from "@shared/v2/IconButton";

const iconMap = {
  CheckSolidV6,
  PencilSolidV6,
  EyeSolidV6,
  TrashSolidV6,
};

const CardAppointmentMenu = ({
  deleteAppointmentFn,
  viewDetailsFn,
  editFn,
  completeFn,
  isCompleted,
  btnSize,
}) => {
  const dropdownLinks = [
    ...(!isCompleted
      ? [{ key: "complete", onClick: completeFn, icon: "CheckSolidV6", text: "Complete" }]
      : []),
    { key: "edit", onClick: editFn, icon: "PencilSolidV6", text: "Edit" },
    { key: "viewdetails", onClick: viewDetailsFn, icon: "EyeSolidV6", text: "View Details" },
    { key: "delete", onClick: deleteAppointmentFn, icon: "TrashSolidV6", text: "Delete" },
  ];

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <IconButton schema="tertiary" size={btnSize} aria-label="menu">
          <EllipsisSolidV6 />
        </IconButton>
      </PopoverTrigger>

      <PopoverContent className="!tw-z-[3001]">
        {dropdownLinks.map((link) => {
          const IconComponent = iconMap[link.icon];
          return (
            <PopoverItem key={link.key} onClick={link.onClick}>
              <IconComponent />
              {link.text}
            </PopoverItem>
          );
        })}
      </PopoverContent>
    </Popover>
  );
};

CardAppointmentMenu.propTypes = {
  deleteAppointmentFn: PropTypes.func,
  viewDetailsFn: PropTypes.func,
  editFn: PropTypes.func,
  completeFn: PropTypes.func,
  isCompleted: PropTypes.bool,
  btnSize: PropTypes.string,
};

CardAppointmentMenu.defaultProps = {
  deleteAppointmentFn: null,
  viewDetailsFn: null,
  editFn: null,
  completeFn: null,
  isCompleted: false,
  btnSize: "small",
};

export default CardAppointmentMenu;
